<div
  *ngIf="show"
  class="fixed inset-0 flex items-center justify-center bg-opacity-40 z-5000"
  style="background-color: rgba(0, 0, 0, 0.3)"
>
  <div
    class="bg-white p-4 rounded-lg shadow-lg max-w-sm w-full animate-fade-in flex flex-col text-center items-center"
  >
    <img
      src="assets/principal/loading.svg"
      alt="loading"
      width="100"
      height="100"
    />
    <p class="text-gray-700 text-xl">{{ texto }}</p>
  </div>
</div>
